import type { TicketStatus } from '@jq4race/shared';

// JQ4-25: Replace stub VO with backend-aligned display status
// JQ4-26: Add 'delivered' terminal display status

export type PickupDisplayStatus = 'in-queue' | 'claimed' | 'delivered';

export function toPickupDisplayStatus(s: TicketStatus): PickupDisplayStatus {
  if (s === 'in_transit') return 'claimed';
  if (s === 'delivered') return 'delivered';
  return 'in-queue';
}

// Display labels are translated at the UI layer (PickupRow) via i18next;
// this map only carries the i18n key per status so the domain layer stays
// framework-agnostic.
export const PICKUP_STATUS_LABEL_KEY: Record<PickupDisplayStatus, string> = {
  'in-queue': 'status.inQueue',
  claimed: 'status.claimed',
  delivered: 'status.delivered',
};

export const PICKUP_STATUS_VARIANT: Record<PickupDisplayStatus, 'info' | 'success'> = {
  'in-queue': 'info',
  claimed: 'success',
  delivered: 'success',
};
